





















































































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";

interface FormSubmissionEntity {
    form_submission_id: number;
    site_id: number | null;
    form_key: string;
    name: string;
    email: string;
    phone: string;
    subject: string;
    message: string;
    extra_data: string | null;
    mail_sent: number | string;
    is_read: number | string;
    created_at: string;
}

@Component({
    components: {DeleteButton}
})
export default class FormKayitlari extends Vue {
    baseAction: string = "forms";
    items: Array<FormSubmissionEntity> | null = null;
    selected: FormSubmissionEntity | null = null;
    dialog: boolean = false;

    get extraFields() {
        if (!this.selected || !this.selected.extra_data) {
            return [];
        }
        try {
            const parsed = JSON.parse(this.selected.extra_data);
            return Object.keys(parsed).map(key => ({key, value: parsed[key]}));
        } catch (e) {
            return [];
        }
    }

    async show(item: FormSubmissionEntity) {
        this.selected = item;
        this.dialog = true;
        // Okundu olarak işaretlemek için tek kayıt çağrısı
        try {
            await this.$http.get(this.baseAction + "/" + item.form_submission_id);
            item.is_read = 1;
        } catch (e) {
            // okundu işareti kritik değil
        }
    }

    async getItems() {
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }

    created() {
        this.getItems();
    }
}
